import { Component, OnInit } from '@angular/core';
import { NewmemberService } from 'src/app/services/newmember.service';

@Component({
  selector: 'app-digitaldeclaration',
  templateUrl: './digitaldeclaration.component.html',
  styleUrls: ['./digitaldeclaration.component.css']
})
export class DigitalDeclarationComponent implements OnInit {
  pdfSrc: string;
  declDocumentType : String;

  constructor(public  nms: NewmemberService) {
  }

  ngOnInit() {
    
   this.declDocumentType = this.nms.declDocumentType;
   this.declDocumentType = this.declDocumentType.replace(/\s+/g,"_")
    this.pdfSrc = './../../../assets/declaration/' + this.declDocumentType + '.pdf';
  }

}
